import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TransportFormComponent } from "./pages/transport-form/transport-form.component";

const routes: Routes = [
  { path: "", redirectTo: "/datos-transporte", pathMatch: "full" },
  { path: "datos-transporte", component: TransportFormComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
